module.exports = __webpack_public_path__ + "img/game7.01d3be9c.png";